
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test",
      function () {
        return require("private-next-pages/test/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/test"])
      });
    }
  